import React, { useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select, styled } from '@mui/material';
import { SelectDropDown } from "../../pages/Theme";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

// Styled Components
// const StyledFormControl = styled(FormControl)(({ theme }) => ({  
//     backgroundColor: '#2084D4', // Custom background for d  ropdown
//     borderRadius: '5px',
//     color: '#fff',
//     fontWeight: '600 !important',
//     '& .MuiInputLabel-root': {
//         color: '#fff', // Label color
//     },
//     '& .MuiSvgIcon-root': {
//         color: '#fff',
//     },
//     '& .MuiOutlinedInput-notchedOutline': {
//         borderColor: '#2084D4', // Outline color
//     },
//     '&:hover .MuiOutlinedInput-notchedOutline': {
//         borderColor: '#2084D4', // Outline color on hover
//     },
// }));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    fontSize: '14px',
    color: '#000', // Text color
    '&:hover': {
        backgroundColor: '#f0f0f0', // Hover effect for items
    },
}));

const SelectModalDropDown = ({ className, option, onChange, defaultValue, disabled }) => {
    let defaultModelVal = (option?.reflection?.filter(x => x.id === defaultValue)[0]?.id) || '';
    const [modelValue, setModelValue] = useState(defaultModelVal || "");
    const handleChange = (event) => {
        const selectedValue = event.target.value;
        if (modelValue === selectedValue) {
            setModelValue('');
            onChange('');
        } else {
            setModelValue(selectedValue);
            onChange(selectedValue || '');  // Ensure `onChange` is called with '' if value is empty
        }
    };

    function handleClick() {
        if (modelValue !== '') {
            setModelValue('');
            onChange('');
        }
    }

    return (
        <>
            {/* <Select
                    value={modelValue || ''}
                    onChange={handleChange}  
                    displayEmpty
                    disabled={disabled}
                    style={{  padding: '0px', height: '35px' }}
                    inputProps={{ 'aria-label': 'Without label' }}
                    className="roundedModel font-semibold text-xs lg:text-sm w-full"
                    sx={{
                        '& .MuiSelect-select': {
                            padding: '10px !important',
                            textAign: 'center !important',
                            borderRadius: '0.5rem !important',
                            fontSize: '14px !important',
                            fontWeight: '500 !important',
                        },
                    }}
                >
                    <StyledMenuItem value="" onClick={handleClick}>
                        Select Model
                    </StyledMenuItem>
                    {option?.reflection?.map((i, index) => (
                        <StyledMenuItem key={index} value={i.id}>
                            {i.display_name}
                        </StyledMenuItem>
                    ))}
                </Select> */}
            <Select
                value={modelValue || ""}
                onChange={handleChange}
                displayEmpty
                disabled={disabled}
                className="roundedModel font-semibold text-xs lg:text-sm"
                style={{ height: "35px", padding: 0, minWidth: "0" }}
                inputProps={{ "aria-label": "Without label" }}
                IconComponent={KeyboardArrowDownIcon}
                sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                    },
                    "& .MuiSelect-select": {
                        padding: "6px 28px 6px 8px !important",
                        borderRadius: "0.5rem !important",
                        fontSize: "14px !important",
                        fontWeight: "500 !important",
                        display: "flex",
                        alignItems: "center",
                        display: "block",              // 👈 needed for ellipsis
                        whiteSpace: "nowrap !important",
                        overflow: "hidden !important",
                        textOverflow: "ellipsis !important",
                    },
                    "& .MuiSelect-icon": {
                        right: "4px",
                    },
                    "& .MuiMenuItem-root": {
                        whiteSpace: "normal", // 👈 allow full wrap in dropdown menu
                        wordBreak: "break-word",
                    },
                }}
                MenuProps={{
                    disableScrollLock: true,
                }}
            >
                <MenuItem value="">Select Model</MenuItem>
                {option?.reflection?.map((i, index) => (
                    <MenuItem key={index} value={i.id}>
                        {i.display_name}
                    </MenuItem>
                ))}
            </Select>
        </>
    );
};

export default SelectModalDropDown;